const leafletGlobal =
  (typeof globalThis !== 'undefined' && globalThis.L) ||
  (typeof window !== 'undefined' && window.L) ||
  undefined;

if (!leafletGlobal) {
  throw new Error('Leaflet global namespace (window.L) is required before loading the non-ESM build.');
}

const { Control, DomEvent, DomUtil, GridLayer, Util } = leafletGlobal;

export { Control, DomEvent, DomUtil, GridLayer, Util };
